import React, { useState } from "react";
import api from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Pencil } from "lucide-react";
import { toast } from "sonner";
import { apiErr, fmtQ, toNum } from "@/merenda/common";

export const ConfirmedList = ({ docs, foodMap, locked, scopeParams, onChange }) => {
  const [edit, setEdit] = useState(null);
  const [qty, setQty] = useState("");
  const [reason, setReason] = useState("");
  const [busy, setBusy] = useState(false);

  const save = async () => {
    if (reason.trim().length < 3) return toast.error("Informe o motivo da correção");
    setBusy(true);
    try {
      await api.post(`/merenda/consumptions/${edit.doc.id}/correct`, { food_id: edit.item.food_id, new_qty: toNum(qty), reason }, { params: scopeParams });
      toast.success("Correção registrada (estoque ajustado pela diferença)");
      setEdit(null); onChange();
    } catch (e) { toast.error(apiErr(e)); } finally { setBusy(false); }
  };

  if (!docs.length) return null;
  return (
    <Card className="mt-6 border-slate-200 p-4" data-testid="consumo-confirmed-list">
      <h3 className="mb-3 font-display font-semibold text-slate-800">Lançamentos confirmados</h3>
      {docs.map((d) => (
        <div key={d.id} className="mb-3 rounded-lg bg-slate-50 p-3 text-sm">
          <div className="mb-1 text-xs text-slate-500">Por {d.confirmed_by_name} em {new Date(d.confirmed_at).toLocaleString("pt-BR")}</div>
          {d.no_prep ? <div className="font-medium text-slate-700">Sem preparo — {d.justification}</div> : d.items.map((it) => (
            <div key={it.food_id} className="flex items-center justify-between border-b border-slate-200 py-1 last:border-0">
              <span>{foodMap[it.food_id]?.name} {it.additional && <em className="text-xs text-amber-700">(adicional)</em>}</span>
              <span className="flex items-center gap-2 font-semibold">{fmtQ(it.qty)} {foodMap[it.food_id]?.unit}
                {!locked && <Button size="icon" variant="ghost" className="h-7 w-7" onClick={() => { setEdit({ doc: d, item: it }); setQty(String(it.qty)); setReason(""); }} data-testid={`consumo-correct-${d.id}-${it.food_id}`}><Pencil className="h-3.5 w-3.5" /></Button>}
              </span>
            </div>
          ))}
        </div>
      ))}
      <Dialog open={!!edit} onOpenChange={(o) => !o && setEdit(null)}>
        <DialogContent data-testid="correction-dialog">
          <DialogHeader><DialogTitle>Corrigir lançamento</DialogTitle></DialogHeader>
          {edit && <p className="text-sm text-slate-500">{foodMap[edit.item.food_id]?.name}: valor anterior <b>{fmtQ(edit.item.qty)} {foodMap[edit.item.food_id]?.unit}</b></p>}
          <div><Label>Novo valor</Label><Input inputMode="decimal" value={qty} onChange={(e) => setQty(e.target.value)} data-testid="correction-qty" /></div>
          <div><Label>Motivo</Label><Input value={reason} onChange={(e) => setReason(e.target.value)} data-testid="correction-reason" /></div>
          <DialogFooter><Button onClick={save} disabled={busy} data-testid="correction-save">Salvar correção</Button></DialogFooter>
        </DialogContent>
      </Dialog>
    </Card>
  );
};
